import { data } from '../../svg/BarChart/data';
import { makeIcon } from '../makeIcon';

export const BarChart = makeIcon(data, 'bar_chart', 'BarChart');

export default BarChart;
